import { useResidentContext } from "app/features/residents/provider/ResidentProvider";
import { FormEnums } from "app/services/api/types/forms/enums/FormEnums";
import { AssessmentReportFillTemplate } from "../../../features/reporting/templates/AssessmentReportFillTemplate";

export function AddVitalSignsReport() {
  const { resident } = useResidentContext();

  const backPath = resident?.id
    ? `/residents/${resident.id}/parameters`
    : undefined;

  return (
    <AssessmentReportFillTemplate
      tag={FormEnums.VITAL_SIGNS}
      backPath={backPath}
    />
  );
}
